/* eslint-disable no-shadow */
import React from 'react';
import PropTypes from 'prop-types';

import LoadingCard from '../../cards/LoadingCard';
import UpgradeCheckList from '../UpgradeCheckList';
import ListItem from '../UpgradeCheckList/ListItem';

import TrackedClick from '../../Analytics/TrackedClick';
import { getClickAttrs } from '../../Analytics/gtag';

import styles from './upgrade.scss';

const PowerEventUpgradeContent = props => {
    const {
        data,
        isLoading,
        onClick,
        referral,
        user,
        yearlySubscriptionOnly,
    } = props;

    const handleClick = (ev, interval) => {
        ev.preventDefault();
        onClick(ev, interval);
    };

    const buttonText = 'UPGRADE TO POWER';

    return (
        <div>
            {!isLoading ? (
                <>
                    <UpgradeCheckList
                        title={data.title}
                        intro={data.subtitle}
                    >
                        {data?.bulletpoints?.map(bulletpoint => (
                            <ListItem>{bulletpoint}</ListItem>
                        ))}
                    </UpgradeCheckList>
                    {!user?.isPowered && (
                        <div>
                            {yearlySubscriptionOnly ? (
                                <>
                                    <div className={`d-flex flex-row ${styles.buttonArea}`}>
                                        <div className="w-100">
                                            <TrackedClick
                                                eventName="Upgrade Cta Clicked"
                                                label={buttonText}
                                                traits={
                                                            {
                                                                pageLocation: 'Upgrade to Power Popup',
                                                                uxType: 'button',
                                                                content: buttonText,
                                                                subscriptionType: 'power',
                                                            }
}
                                            >
                                                <button
                                                    type="button"
                                                    className={`w-100 btn btn-primary btn-xl font-weight-normal p0 ${styles.pricingText}`}
                                                    onClick={(e) => handleClick(e, 'year')}
                                                    data-testid="upgrade-power.event.upgrade-btn"
                                                    {...getClickAttrs({
                                                                category: 'Power Upgrade',
                                                                context: buttonText,
                                                                location: 'Upgrade to Power Popup',
                                                            })}
                                                >
                                                    {buttonText}
                                                </button>
                                            </TrackedClick>
                                        </div>
                                    </div>
                                </>
                                ) : (
                                    <>
                                        <div className={`d-flex flex-row ${styles.buttonArea}`}>
                                            <div className="w-100">
                                                <TrackedClick
                                                    eventName="Upgrade Cta Clicked"
                                                    label={buttonText}
                                                    traits={
                                                        {
                                                            pageLocation: 'Upgrade to Power Popup',
                                                            uxType: 'button',
                                                            content: buttonText,
                                                            subscriptionType: 'power',
                                                        }
}
                                                >
                                                    <button
                                                        type="button"
                                                        className={`w-100 btn btn-primary btn-xl font-weight-normal p0 ${styles.pricingText}`}
                                                        onClick={(e) => handleClick(e, 'year')}
                                                        {...getClickAttrs({
                                                            category: 'Power Upgrade',
                                                            context: buttonText,
                                                            location: 'Upgrade to Power Popup',
                                                        })}
                                                    >
                                                        {buttonText}
                                                    </button>
                                                </TrackedClick>
                                                {referral && <p className={styles.discountDescription}>(If you used a discount link, click to see discounted price)</p>}
                                            </div>
                                        </div>
                                        {!referral && (
                                            <div className={`text-center mt16 ${styles.footerText}`}>
                                                <TrackedClick
                                                    eventName="Upgrade Cta Clicked"
                                                    label={buttonText}
                                                    traits={
                                                        {
                                                            pageLocation: 'Upgrade to Power Popup',
                                                            uxType: 'link',
                                                            content: buttonText,
                                                            subscriptionType: 'power',
                                                        }
}
                                                >
                                                    <u>
                                                        <a
                                                            className="clickable"
                                                            onClick={(e) => handleClick(e, 'month')}
                                                            {...getClickAttrs({
                                                                category: 'Power Upgrade',
                                                                context: buttonText,
                                                                location: 'Upgrade to Power Popup',
                                                            })}
                                                        >
                                                            {buttonText}
                                                        </a>
                                                    </u>
                                                </TrackedClick>
                                            </div>
                                        )}
                                    </>
                                )}
                        </div>
                    )}
                </>
                ) : <LoadingCard />}
        </div>

    );
};

PowerEventUpgradeContent.propTypes = {
    data: PropTypes.shape({
        bulletpoints: PropTypes.arrayOf(PropTypes.string),
        subtitle: PropTypes.string,
        title: PropTypes.string,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    referral: PropTypes.bool.isRequired,
    user: PropTypes.shape({
        isPowered: PropTypes.bool,
    }).isRequired,
    yearlySubscriptionOnly: PropTypes.bool,
};

PowerEventUpgradeContent.defaultProps = {
    yearlySubscriptionOnly: false,
};

export default PowerEventUpgradeContent;
